import React from "react";
// Layouts
import AuthLayout from "./layouts/Auth";
import PresentationLayout from "./layouts/Presentation";
import NormalLayout from "./layouts/Normal";
import SuperAdminLayout from "./layouts/_new/SuperAdmin";

// Guards
import AuthGuard from "./components/guards/AuthGuard";
import SuperGuard from "./components/guards/SuperGuard";

// Contexts
import { HomeProvider } from "./contexts/user/HomeContext";
import { AdminProvider } from "./contexts/user/AdminContext";
import { EventProvider } from "./contexts/user/EventContext";
import { WAFRuleProvider } from "./contexts/user/WAFConfigContext";
import { BMConfigProvider } from "./contexts/user/BMConfigContext";
import { DdosConfigProvider } from "./contexts/user/DdosConfigContext";
import { CspConfigProvider } from "./contexts/user/CspConfigContext";
import { SiteProvider } from "./contexts/user/SiteContext";
import { ZoneProvider } from "./contexts/user/ZoneContext";
import { SslConfigProvider } from "./contexts/user/SSLConfigContext";
import { FirewallProvider } from "./contexts/user/FirewallContext";
import { RateLimitProvider } from "./contexts/user/RateLimitContext";
import { FindingsProvider } from "./contexts/user/FindingsContext";
import { KeyProvider } from "./contexts/user/KeyContext";

import { GeneralProvider } from "./contexts/super/GeneralContext";
import { LogProvider } from "./contexts/super/LogContext";
import { OrganisationProvider } from "./contexts/super/OrganisationContext";
import { UserProvider } from "./contexts/super/UserContext";
// WAFEdgeContext is retained — Region modal + SSL cert config still use it.
import { WAFEdgeProvider } from "./contexts/super/nodes/WAFEdgeContext";
import { RegionProvider } from "./contexts/super/RegionContext";
import { ClickHouseProvider } from "./contexts/super/ClickHouseContext";
import { SSLProvider } from "./contexts/super/SSLContext";
import { ApiKeyProvider } from "./contexts/super/ApiKeyContext";
import { CaptchaProvider } from "./contexts/super/CaptchaContext";
import { RuleProvider } from "./contexts/super/RuleContext";
import { PaymentProvider } from "./contexts/super/PaymentContext";
import { ZcrmProvider } from "./contexts/super/ZcrmContext";
import { BMProvider } from "./contexts/super/BMContext";
import { ADProvider } from "./contexts/super/ADContext";
import { AdExceptionProvider } from "./contexts/super/ADExceptionContext";
import { SmartParseProvider } from "./contexts/super/SmartParseContext";

// LLM Providers
import { LLMEventProvider } from "./contexts/user/LLMEventContext";
import { LLMConfigProvider } from "./contexts/user/LLMConfigContext";
import { LLMSslConfigProvider } from "./contexts/user/LLMSSLConfigContext";
import { LLMFirewallProvider } from "./contexts/user/LLMFirewallContext";
import { LLMRateLimitProvider } from "./contexts/user/LLMRateLimitContext";

// Landing
import Landing from "./pages/landing";
// Auth components
/*
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import SignOut from "./pages/auth/SignOut";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
*/
import VerifyEmail from "./pages/auth/VerifyEmail";
import CompleteOnboarding from "./pages/auth/CompleteOnboarding";
import Page404 from "./pages/error/Page404";
import Page500 from "./pages/error/Page500";
import { Navigate } from "react-router-dom";

// Home
import Home from "./pages/home";

// LLM Zones
import LLMZone from "./pages/llm";
import Zones from "./pages/llm/zones.js";
import NewZone from "./pages/llm/newZone.js";
import LLMSSLOverview from "./pages/llm/ssl/overview";
import LLMSSLConfig from "./pages/llm/ssl/config";
import LLMFirewall from "./pages/llm/firewall";
import LLMNewFirewall from "./pages/llm/firewall/new";
import LLMEditFirewall from "./pages/llm/firewall/edit";
import LLMRateLimit from "./pages/llm/ratelimit";
import LLMNewRateLimit from "./pages/llm/ratelimit/new";
import LLMEditRateLimit from "./pages/llm/ratelimit/edit";

// application/waf

// llm/guard
import LLMDashboard from "./pages/llm/guard/dashboard";
import LLMConfig from "./pages/llm/guard/config";
import LLMPromptScanners from "./pages/llm/guard/llmPromptScanners";
import LLMOutputScanners from "./pages/llm/guard/llmOutputScanners";
import LLMAPITokens from "./pages/llm/guard/llmAPITokens";

// application/bot

// application/ddos

// application/admin
// === Locked-feature alignment additions ===
import DdosBlocks from "./pages/super/admin/ddosBlocks";
import GlobalConfig from "./pages/super/admin/globalConfig";
// === API Security pages (v2-native) ===
import AsecOverview from "./components/pages/_new/services/api_security/Overview";
import AsecCatalog from "./components/pages/_new/services/api_security/Catalog";
import AsecDiscovery from "./components/pages/_new/services/api_security/Discovery";
import AsecSchemaValidation from "./components/pages/_new/services/api_security/SchemaValidation";
import AsecAuth from "./components/pages/_new/services/api_security/Auth";
import AsecSpecs from "./components/pages/_new/services/api_security/Specs";
import AsecDlp from "./components/pages/_new/services/api_security/Dlp";
import AsecGraphql from "./components/pages/_new/services/api_security/Graphql";
import AsecPosture from "./components/pages/_new/services/api_security/Posture";
import AsecAnomaly from "./components/pages/_new/services/api_security/Anomaly";
import AsecAuthorization from "./components/pages/_new/services/api_security/Authorization";
import AsecRiskScore from "./components/pages/_new/services/api_security/RiskScore";
import AsecThreatIntel from "./components/pages/_new/services/api_security/ThreatIntel";
import AsecProposals from "./components/pages/_new/services/api_security/Proposals";
import AsecDependencies from "./components/pages/_new/services/api_security/Dependencies";
import AsecAiCallers from "./components/pages/_new/services/api_security/AiCallers";
import AsecSiem from "./components/pages/_new/services/api_security/Siem";
import AsecEvents from "./components/pages/_new/services/api_security/Events";
import AsecEventsCapture from "./components/pages/_new/services/api_security/EventsCapture";
// === v2 rich exceptions pages ===
import V2BmExceptions from "./components/pages/_new/services/bot/BmExceptions";
import V2DdosExceptions from "./components/pages/_new/services/ddos/DdosExceptions";




// application/analytics




// llm/analytics
import LLMAnalyticsEvents from "./pages/llm/analytics/events";
import LLMAnalyticsEventsDetail from "./pages/llm/analytics/detail";

import LLMAnalyticsRLEvents from "./pages/llm/analytics/rl_events";
import LLMAnalyticsRLEventsDetail from "./pages/llm/analytics/rl_detail";

import LLMAnalyticsFirewallEvents from "./pages/llm/analytics/fw_events";
import LLMAnalyticsFirewallEventsDetail from "./pages/llm/analytics/fw_detail";

// profile

// Super Admin
import SADataRetention from "./pages/super/dataRetention";
import SAClickHouse from "./pages/super/clickhouse";
import SAEmailConfiguration from "./pages/super/general/email";
import SAInvoiceConfiguration from "./pages/super/general/invoice";
import SANotificationConfiguration from "./pages/super/general/notification";
import SALog from "./pages/super/log";
import SAOrganisation from "./pages/super/organisation";
// import SAZcrmApiConfig from "./pages/super/zcrm/api_config";
// import SAZcrmProduct from "./pages/super/zcrm/product";
// import SAZcrmAccountContact from "./pages/super/zcrm/account_contact";
// import SAZcrmQuote from "./pages/super/zcrm/quote";
/*
import SABmLicenseUsage from "./pages/super/bm/license_usage";
import SABMPackage from "./pages/super/bm/package";
*/
import SAAwsS3Cfgs from "./pages/super/bm/aws_s3";
// 2026-06-30 P2 — BM threat-list admin (5 Redis sets read by BM-Engine
// + pingora). Self-contained page, no provider needed; uses adminAxios
// directly.
import SAThreatLists from "./pages/super/bm/threatLists";
// 2026-06-30 P3a — per-detector shadow/canary/authoritative admin +
// pipeline kill switch. Reads bm:config:detectors / bm:config:aggregator
// via the same lib/bm_redis client introduced for P2.
import SADetectorRollout from "./pages/super/bm/detectorRollout";
import SASmartParse from "./pages/super/smartparse";
import SAAdCfgs from "./pages/super/ad/config";
import SAAdException from "./pages/super/ad/exception";
import SASdRule from "./pages/super/rule/sd";
import SACustomRule from "./pages/super/rule/custom/index";
import SANewCustomRule from "./pages/super/rule/custom/new";
import SAEditCustomRule from "./pages/super/rule/custom/edit";
import SASSL from "./pages/super/ssl";
import SAOtxApiKey from "./pages/super/apikey/otx";
import SAAbuseIpDbApiKey from "./pages/super/apikey/abuseipdb";
import SACaptchaGeneral from "./pages/super/captcha/general";
import SACaptchaApiKeys from "./pages/super/captcha/api_keys";
import SACaptchaBlockPage from "./pages/super/captcha/block_pages";
import SAAdmins from "./pages/super/user/admins";
import SAUser from "./pages/super/user";
import SAUserReport from "./pages/super/user/report";
import SARegionList from "./pages/super/region";
import SAWAFConfig from "./pages/super/waf/config";
import SAHome from "./pages/super";
import SAApplication from "./pages/super/application";
import SAProfile from "./pages/super/profile";
// Step 6 — super-admin engine monitoring pages (Pingora / BM / AD).
import SAEnginesPingoraCluster from "./pages/super/engines/pingora";
import SAEnginesPingoraDetail from "./pages/super/engines/pingora/Detail";
import SAEnginesBmCluster from "./pages/super/engines/bm";
import SAEnginesBmDetail from "./pages/super/engines/bm/Detail";
import SAEnginesAdCluster from "./pages/super/engines/ad";
import SAEnginesAdDetail from "./pages/super/engines/ad/Detail";
// Phase 1c — super-admin licensing v2 (consumes /api/admin/licensing/*).
import SALicensingIndex from "./pages/super/licensing";
import SALicensingDetail from "./pages/super/licensing/Detail";
// Threat Insights catalog manager (consumes /api/admin/threat-insights/*).
import SAThreatInsightRules from "./pages/super/threat_insights/component/T_ThreatInsightRules";
import SAThreatInsightSuppressions from "./pages/super/threat_insights/component/T_ThreatInsightSuppressions";
// Bug reports + JIRA integration (consumes /api/admin/bug-reports + /api/admin/integrations/jira).
import SABugReports from "./pages/super/bug_reports/component/T_BugReports";
import SAJiraSettings from "./pages/super/integrations/component/T_JiraSettings";
// System-scope alert console.
import SuperAdminAlerts from "./pages/super/alerts";
import { IdPProvider } from "./contexts/user/IdPContext";
import { DomainProvider } from "./contexts/user/DomainContext";
import { IPRestrictionProvider } from "./contexts/user/IPRestrictionContext";
import { SessionSettingsProvider } from "./contexts/user/SessionSettingsContext";
import AgreePolicy from "./pages/auth/AgreePolicy";
import LogIn from "./pages/auth/LogIn";
import Page403 from "./pages/error/Page403";

import NewNormalLayout from "./layouts/_new/Normal.js";
import NewOverviewPage from "./components/pages/_new/overview/index.js";
import NewFindingsPage from "./components/pages/_new/findings/index.js";
import LegacyFindingsRedirect from "./components/pages/_new/findings/LegacyFindingsRedirect.js";
import NewSitesPage from "./components/pages/_new/sites/index.js";
import SSLTlsOverviewPage from "./components/pages/_new/certs/SSLTlsOverviewPage.js";
import SSLTlsConfigurationPage from "./components/pages/_new/certs/SSLTlsConfigurationPage.js";
import LegacyCertsRedirect from "./components/pages/_new/certs/LegacyCertsRedirect.js";
import NewReportsPage from "./components/pages/_new/reports/index.js";
import AddSitesPage from "./components/pages/_new/sites/new.js";

import NewAccountSettingsPage from "./components/pages/_new/settings/account.js";
import NewOrganisationSettingsPage from "./components/pages/_new/settings/organisation.js";
import NewProjectSettingsPage from "./components/pages/_new/settings/project.js";
import NewLicensePage from "./components/pages/_new/settings/LicensePage.js";

import WAFEventPage from "./components/pages/_new/detection/WAFEvent.js";
import FirewallEventPage from "./components/pages/_new/detection/FirewallEvent.js";
import BotEventPage from "./components/pages/_new/detection/BotEvent.js";
import RateLimitEventPage from "./components/pages/_new/detection/RateLimitEvent.js";
import WAFEventView from "./components/pages/_new/detection/WAFEventView.js";
import FirewallEventViewPage from "./components/pages/_new/detection/FirewallEventView.js";
import BotEventViewPage from "./components/pages/_new/detection/BotEventView.js";
import RateLimitEventViewPage from "./components/pages/_new/detection/RateLimitEventView.js";

import NewServicesBotConfig from "./components/pages/_new/services/bot/Config.js";
import NewServicesBotDashboard from "./components/pages/_new/services/bot/Dashboard.js";
import NewServicesDDosMigrationConfig from "./components/pages/_new/services/ddos/DDosMigrationConfig.js";
import NewServicesCspInventory from "./components/pages/_new/services/csp/Inventory.js";
import NewServicesMcpConfig from "./components/pages/_new/services/mcp/Config.js";
import NewServicesMcpOverview from "./components/pages/_new/services/mcp/Overview.js";
import NewServicesMcpEndpointsList from "./components/pages/_new/services/mcp/EndpointsList.js";
import NewServicesMcpEvents from "./components/pages/_new/services/mcp/Events.js";
import NewServicesMcpEndpointSettings from "./components/pages/_new/services/mcp/EndpointSettings.js";
import NewServicesMcpSettingsIndex from "./components/pages/_new/services/mcp/SettingsIndex.js";
import NewServicesMcpOnboarding from "./components/pages/_new/services/mcp/Onboarding.js";
import NewServicesMcpTools from "./components/pages/_new/services/mcp/Tools.js";
import NewServicesMcpSessions from "./components/pages/_new/services/mcp/Sessions.js";
import NewServicesMcpApprovals from "./components/pages/_new/services/mcp/Approvals.js"; // MCP_ROADMAP_UI_2026_11_03
import NewServicesMcpDiscovered from "./components/pages/_new/services/mcp/Discovered.js";
import NewServicesMcpAgents from "./components/pages/_new/services/mcp/Agents.js";
import NewServicesMcpPolicyLibrary from "./components/pages/_new/services/mcp/PolicyLibrary.js";
import NewServicesMcpAlerts from "./components/pages/_new/services/mcp/Alerts.js";
import NewServicesMcpReports from "./components/pages/_new/services/mcp/Reports.js";
import McpLicenseGate from "./components/pages/_new/services/mcp/_shared/McpLicenseGate.js";
import NewServicesCspPolicy from "./components/pages/_new/services/csp/Policy.js";
import NewServicesCspViolations from "./components/pages/_new/services/csp/Violations.js";
import NewServicesCspRoutes from "./components/pages/_new/services/csp/Routes.js";
import NewServicesCspIntelligence from "./components/pages/_new/services/csp/Intelligence.js";
import NewServicesCspOverride from "./components/pages/_new/services/csp/Override.js";
import NewServicesFirewallRules from "./components/pages/_new/services/firewall/FirewallRules.js";
import NewServicesRateLimitingRules from "./components/pages/_new/services/rate_limit/RateLimitingRules.js";
import NewServicesWebApplicationDashboard from "./components/pages/_new/services/web_application/Dashboard.js";
import NewServicesWebApplicationConfig from "./components/pages/_new/services/web_application/Config.js";
import NewServicesWebApplicationExceptions from "./components/pages/_new/services/web_application/Exceptions.js";
import NewServicesWebApplicationCustomRules from "./components/pages/_new/services/web_application/CustomRules.js";
import WAFConfigurationStatus from "./components/pages/_new/services/web_application/WAFConfigurationStatus.js";

import WebApplicationDetectionDetail from "./components/pages/_new/services/web_application/DetectionDetail.js";
import WebApplicationDetectionList from "./components/pages/_new/services/web_application/DetectionList.js";

import BotDetectionDetail from "./components/pages/_new/services/bot/DetectionDetail.js";
import BotDetectionList from "./components/pages/_new/services/bot/DetectionList.js";

import ExternalWebhooksPage from "./components/pages/_new/settings/webhooks.js";
import SSOPage from "./components/pages/_new/settings/sso.js";
import AuditLogsPage from "./components/pages/_new/settings/auditlogs.js";
import AlertsPage from "./components/pages/_new/settings/AlertsPage.js";
import UserManagement from "./components/pages/_new/settings/usermanagement.js";
import { RBACProvider } from "./contexts/user/RBACContext";

const routes = [
  {
    path: "super/application",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      {
        path: "",
        element: <SAApplication />,
      },
      {
        path: "data_retention",
        element: <SADataRetention />,
      },
      {
        path: "clickhouse",
        element: (
          <ClickHouseProvider>
            <SAClickHouse />
          </ClickHouseProvider>
        ),
      },
      {
        path: "general/email",
        element: (
          <GeneralProvider>
            <SAEmailConfiguration />
          </GeneralProvider>
        ),
      },
      {
        path: "general/invoice",
        element: (
          <GeneralProvider>
            <SAInvoiceConfiguration />
          </GeneralProvider>
        ),
      },
      {
        path: "general/notification",
        element: (
          <GeneralProvider>
            <SANotificationConfiguration />
          </GeneralProvider>
        ),
      },
      {
        path: "log",
        element: (
          <LogProvider>
            <SALog />
          </LogProvider>
        ),
      },
      // Legacy /super/application/monitor/* + /stats/* routes removed in
      // Step 7a (2026-05-30). The new engine monitoring lives at
      // /super/engines/{pingora,bm,ad}.
      {
        path: "organisation",
        element: (
          <OrganisationProvider>
            <SAOrganisation />
          </OrganisationProvider>
        ),
      },
      // {
      //   path: "payment/stripe_config",
      //   element: (
      //     <PaymentProvider>
      //       <SAStripeConfig />
      //     </PaymentProvider>
      //   ),
      // },
      // {
      //   path: "payment/history",
      //   element: (
      //     <PaymentProvider>
      //       <SAPaymentHistoryOriginal />
      //     </PaymentProvider>
      //   ),
      // },
      // {
      //   path: "payment/history",
      //   element: (
      //     <PaymentProvider>
      //       <SAPaymentHistoryCustom />
      //     </PaymentProvider>
      //   ),
      // },
      /*{
        path: "zcrm/api_config",
        element: (
          <ZcrmProvider>
            <SAZcrmApiConfig />
          </ZcrmProvider>
        ),
      },
      {
        path: "zcrm/product",
        element: (
          <ZcrmProvider>
            <SAZcrmProduct />
          </ZcrmProvider>
        ),
      },
      {
        path: "zcrm/account_contact",
        element: (
          <ZcrmProvider>
            <PaymentProvider>
              <SAZcrmAccountContact />
            </PaymentProvider>
          </ZcrmProvider>
        ),
      },
      {
        path: "zcrm/quote",
        element: (
          <ZcrmProvider>
            <PaymentProvider>
              <SAZcrmQuote />
            </PaymentProvider>
          </ZcrmProvider>
        ),
      },*/
      {
        path: "bm/aws_s3",
        element: (
          <BMProvider>
            <SAAwsS3Cfgs />
          </BMProvider>
        ),
      },
      {
        path: "bm/threat-lists",
        element: <SAThreatLists />,
      },
      {
        path: "bm/detector-rollout",
        element: <SADetectorRollout />,
      },
      {
        path: "smartparse",
        element: (
          <OrganisationProvider>
            <SmartParseProvider>
              <SASmartParse />
            </SmartParseProvider>
          </OrganisationProvider>
        ),
      },
      /*
            {
                path: "bm/license",
                element: (
                    <BMProvider>
                        <SABmLicenseUsage />
                    </BMProvider>
                ),
            },
            {
                path: "bm/package",
                element: (
                    <BMProvider>
                        <SABMPackage />
                    </BMProvider>
                ),
            },
            {
                path: "bm/payment",
                element: (
                    <BMProvider>
                        <SABMPayment />
                    </BMProvider>
                ),
            },
            */
      {
        path: "ad/blocks",
        element: <DdosBlocks />,
      },
      {
        path: "global-config",
        element: <GlobalConfig />,
      },
      {
        path: "ad/config",
        element: (
          <ADProvider>
            <SAAdCfgs />
          </ADProvider>
        ),
      },
      {
        path: "ad/exception",
        element: (
          <AdExceptionProvider>
            <OrganisationProvider>
              <SAAdException />
            </OrganisationProvider>
          </AdExceptionProvider>
        ),
      },
      {
        path: "rule/sd",
        element: (
          <RuleProvider>
            <SASdRule />
          </RuleProvider>
        ),
      },
      {
        path: "rule/custom",
        element: (
          <RuleProvider>
            <SACustomRule />
          </RuleProvider>
        ),
      },
      {
        path: "rule/custom/new",
        element: (
          <RuleProvider>
            <SANewCustomRule />
          </RuleProvider>
        ),
      },
      {
        path: "rule/custom/edit/:customRuleId",
        element: (
          <RuleProvider>
            <SAEditCustomRule />
          </RuleProvider>
        ),
      },
      {
        path: "ssl",
        element: (
          <SSLProvider>
            <SASSL />
          </SSLProvider>
        ),
      },
      {
        path: "apikey/otx",
        element: (
          <ApiKeyProvider>
            <SAOtxApiKey />
          </ApiKeyProvider>
        ),
      },
      {
        path: "apikey/abuseipdb",
        element: (
          <ApiKeyProvider>
            <SAAbuseIpDbApiKey />
          </ApiKeyProvider>
        ),
      },
      {
        path: "captcha/general",
        element: (
          <CaptchaProvider>
            <SACaptchaGeneral />
          </CaptchaProvider>
        ),
      },
      {
        path: "captcha/api_keys",
        element: (
          <CaptchaProvider>
            <SACaptchaApiKeys />
          </CaptchaProvider>
        ),
      },
      {
        path: "captcha/block_pages",
        element: (
          <CaptchaProvider>
            <SACaptchaBlockPage />
          </CaptchaProvider>
        ),
      },
      {
        path: "admins/list",
        element: <SAAdmins />,
      },
      {
        path: "user/list",
        element: <SAUser />,
      },
      {
        path: "user/list/:orgID",
        element: <SAUser />,
      },
      {
        path: "user/report",
        element: <SAUserReport />,
      },
      // Legacy /super/application/{waf,llm,omb,bm,au,ad,es}_engine/list +
      // waf_engine/dashboard routes removed in Step 7a (2026-05-30). The new
      // engine UI lives at /super/engines/{pingora,bm,ad}. waf_edge/config
      // (certificate management) stays.
      {
        path: "waf_edge/config",
        element: (
          <WAFEdgeProvider>
            <SAWAFConfig />
          </WAFEdgeProvider>
        ),
      },
      {
        path: "profile",
        element: <SAProfile />,
      },
      {
        path: "region/list",
        element: (
          <RegionProvider>
            <WAFEdgeProvider>
              <SARegionList />
            </WAFEdgeProvider>
          </RegionProvider>
        ),
      },
    ],
  },
  {
    path: "/super/home",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      {
        path: "",
        element: <SAHome />,
      },
    ],
  },
  // Step 6 — engine monitoring (Pingora / BM-Engine / AD-Engine).
  // Sibling of /super/application so the URLs stay short. Each engine
  // type gets a cluster overview + per-server drill-down. All six leaves
  // are thin wrappers around the two generic templates under
  // components/pages/_new/super/engines/.
  {
    path: "/super/engines",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      { path: "pingora", element: <SAEnginesPingoraCluster /> },
      { path: "pingora/:id", element: <SAEnginesPingoraDetail /> },
      { path: "bm", element: <SAEnginesBmCluster /> },
      { path: "bm/:id", element: <SAEnginesBmDetail /> },
      { path: "ad", element: <SAEnginesAdCluster /> },
      { path: "ad/:id", element: <SAEnginesAdDetail /> },
    ],
  },
  // System-scope alerts page — consumes /api/user/v1/notification, which
  // (for platform admins) includes organisationId-NULL system rows. Lives
  // under the SuperGuard so non-admins never see this URL.
  {
    path: "/super/alerts",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      { path: "", element: <SuperAdminAlerts /> },
    ],
  },
  // Phase 1c — super-admin licensing v2 (org list + per-org detail).
  // Consumes /api/admin/licensing/* (Phase 1b backend, commit 1a56ad91).
  {
    path: "/super/licensing",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      { path: "", element: <SALicensingIndex /> },
      { path: ":org_id", element: <SALicensingDetail /> },
    ],
  },
  // Threat Insights catalog manager (super-admin). Search + filter
  // the 1330-rule catalog, toggle global enable/disable, manage
  // per-organisation overrides via ?org=<id> on the same page.
  {
    path: "/super/threat-insights",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      { path: "", element: <SAThreatInsightRules /> },
      { path: "rules", element: <SAThreatInsightRules /> },
      { path: "suppressions", element: <SAThreatInsightSuppressions /> },
    ],
  },
  // Bug reports + JIRA integration (super-admin only).
  {
    path: "/super/bug-reports",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      { path: "", element: <SABugReports /> },
    ],
  },
  {
    path: "/super/integrations/jira",
    element: (
      <SuperGuard>
        <UserProvider>
          <SuperAdminLayout />
        </UserProvider>
      </SuperGuard>
    ),
    children: [
      { path: "", element: <SAJiraSettings /> },
    ],
  },
  {
    path: "",
    element: <PresentationLayout />,
    children: [
      {
        path: "",
        element: <Landing />,
      },
      {
        path: "auth/login",
        element: <LogIn />,
      },
      {
        path: "auth/forbidden",
        element: <Page403 />,
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      /*
            {
                path: "signin",
                element: <SignIn />,
            },
            {
                path: "signup",
                element: <SignUp />,
            },
            {
                path: "signout",
                element: <SignOut />,
            },
            {
                path: "forgotpassword",
                element: <ForgotPassword />,
            },
            {
                path: "reset-password/:token",
                element: <ResetPassword />,
            },
            */
      {
        path: "verify-email",
        element: <VerifyEmail />,
      },
      {
        path: "complete-onboarding",
        element: <CompleteOnboarding />,
      },
      {
        path: "accept-terms",
        element: <AgreePolicy />,
      },
    ],
  },
  {
    path: "",
    element: (
      <AuthGuard>
        <SiteProvider>
          <NormalLayout />
        </SiteProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: "home",
        element: (
          <HomeProvider>
            <Home />
          </HomeProvider>
        ),
      },
    ],
  },
  {
    path: "llm",
    element: (
      <AuthGuard>
        <ZoneProvider>
          <NormalLayout />
        </ZoneProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <LLMZone />,
      },
      {
        path: "zones",
        element: <Zones />,
      },
      {
        path: "zones/new",
        element: (
          <LLMSslConfigProvider>
            <LLMConfigProvider>
              <NewZone />
            </LLMConfigProvider>
          </LLMSslConfigProvider>
        ),
      },
      {
        path: ":configZone/ssl",
        element: (
          <LLMSslConfigProvider>
            <LLMSSLOverview />
          </LLMSslConfigProvider>
        ),
      },
      {
        path: ":configZone/ssl/config",
        element: (
          <LLMSslConfigProvider>
            <LLMSSLConfig />
          </LLMSslConfigProvider>
        ),
      },
      {
        path: ":configZone/firewall",
        element: (
          <LLMFirewallProvider>
            <LLMFirewall />
          </LLMFirewallProvider>
        ),
      },
      {
        path: ":configZone/firewall/new",
        element: (
          <LLMFirewallProvider>
            <LLMNewFirewall />
          </LLMFirewallProvider>
        ),
      },
      {
        path: ":configZone/firewall/edit/:firewallID",
        element: (
          <LLMFirewallProvider>
            <LLMEditFirewall />
          </LLMFirewallProvider>
        ),
      },
      {
        path: ":configZone/ratelimit",
        element: (
          <LLMRateLimitProvider>
            <LLMRateLimit />
          </LLMRateLimitProvider>
        ),
      },
      {
        path: ":configZone/ratelimit/new",
        element: (
          <LLMRateLimitProvider>
            <LLMNewRateLimit />
          </LLMRateLimitProvider>
        ),
      },
      {
        path: ":configZone/ratelimit/edit/:ratelimitID",
        element: (
          <LLMRateLimitProvider>
            <LLMEditRateLimit />
          </LLMRateLimitProvider>
        ),
      },
    ],
  },
  {
    path: "llm",
    element: (
      <AuthGuard>
        <ZoneProvider>
          <NormalLayout />
        </ZoneProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: ":configZone/guard/dashboard",
        element: <LLMDashboard />,
      },
      {
        path: ":configZone/guard/config",
        element: (
          <LLMConfigProvider>
            <LLMConfig />
          </LLMConfigProvider>
        ),
      },
      {
        path: ":configZone/guard/config/prompt_scanners",
        element: (
          <LLMConfigProvider>
            <LLMPromptScanners />
          </LLMConfigProvider>
        ),
      },
      {
        path: ":configZone/guard/config/output_scanners",
        element: (
          <LLMConfigProvider>
            <LLMOutputScanners />
          </LLMConfigProvider>
        ),
      },
      {
        path: ":configZone/guard/config/api_tokens",
        element: (
          <LLMConfigProvider>
            <LLMAPITokens />
          </LLMConfigProvider>
        ),
      },
    ],
  },
  {
    path: "/llm/analytics",
    element: (
      <AuthGuard>
        <ZoneProvider>
          <NormalLayout />
        </ZoneProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: "events",
        element: (
          <LLMEventProvider>
            <LLMAnalyticsEvents />
          </LLMEventProvider>
        ),
      },
      {
        path: "events/:eventID",
        element: (
          <LLMEventProvider>
            <LLMAnalyticsEventsDetail />
          </LLMEventProvider>
        ),
      },
      {
        path: "fw_events",
        element: (
          <LLMEventProvider>
            <LLMFirewallProvider>
              <LLMAnalyticsFirewallEvents />
            </LLMFirewallProvider>
          </LLMEventProvider>
        ),
      },
      {
        path: "fw_events/:eventID",
        element: (
          <LLMEventProvider>
            <LLMAnalyticsFirewallEventsDetail />
          </LLMEventProvider>
        ),
      },
      {
        path: "rl_events",
        element: (
          <LLMEventProvider>
            <LLMRateLimitProvider>
              <LLMAnalyticsRLEvents />
            </LLMRateLimitProvider>
          </LLMEventProvider>
        ),
      },
      {
        path: "rl_events/:eventID",
        element: (
          <LLMEventProvider>
            <LLMAnalyticsRLEventsDetail />
          </LLMEventProvider>
        ),
      },
    ],
  },
  {
    path: "v2",
    element: (
      <AuthGuard>
        <HomeProvider>
          <SiteProvider>
            <NewNormalLayout />
          </SiteProvider>
        </HomeProvider>
      </AuthGuard>
    ),
    children: [
      {
        path: "overview",
        element: <NewOverviewPage />,
      },
      {
        path: "detection/waf_event",
        element: (
          <EventProvider>
            <WAFEventPage />
          </EventProvider>
        ),
      },
      {
        path: "detection/waf_event/view/:categoryId/:eventId",
        element: (
          <EventProvider>
            <WAFEventView />
          </EventProvider>
        ),
      },
      {
        path: "detection/firewall_event",
        element: (
          <EventProvider>
            <FirewallProvider>
              <FirewallEventPage />
            </FirewallProvider>
          </EventProvider>
        ),
      },
      {
        path: "detection/firewall_event/view/:categoryId/:eventId",
        element: (
          <EventProvider>
            <FirewallProvider>
              <FirewallEventViewPage />
            </FirewallProvider>
          </EventProvider>
        ),
      },
      {
        path: "detection/bot_event",
        element: (
          <EventProvider>
            <BMConfigProvider>
              <BotEventPage />
            </BMConfigProvider>
          </EventProvider>
        ),
      },
      {
        path: "detection/bot_event/view/:categoryId/:eventId",
        element: (
          <EventProvider>
            <BMConfigProvider>
              <BotEventViewPage />
            </BMConfigProvider>
          </EventProvider>
        ),
      },
      {
        path: "detection/rate_limit_event",
        element: (
          <EventProvider>
            <RateLimitProvider>
              <RateLimitEventPage />
            </RateLimitProvider>
          </EventProvider>
        ),
      },
      {
        path: "detection/rate_limit_event/view/:categoryId/:eventId",
        element: (
          <EventProvider>
            <RateLimitProvider>
              <RateLimitEventViewPage />
            </RateLimitProvider>
          </EventProvider>
        ),
      },
      {
        path: "findings",
        element: <LegacyFindingsRedirect />,
      },
      {
        path: "findings/posture",
        element: (
          <FindingsProvider>
            <NewFindingsPage forcedMode="posture" />
          </FindingsProvider>
        ),
      },
      {
        path: "findings/threat-insights",
        element: (
          <FindingsProvider>
            <NewFindingsPage forcedMode="threats" />
          </FindingsProvider>
        ),
      },
      {
        path: "sites",
        element: (
          <SslConfigProvider>
            <WAFRuleProvider>
              <NewSitesPage />
            </WAFRuleProvider>
          </SslConfigProvider>
        ),
      },
      {
        path: "sites/new",
        element: (
          <SslConfigProvider>
            <WAFRuleProvider>
              <AddSitesPage />
            </WAFRuleProvider>
          </SslConfigProvider>
        ),
      },
      {
        path: "ssl-tls",
        element: <Navigate to="/v2/ssl-tls/overview" replace />,
      },
      {
        path: "ssl-tls/overview",
        element: (
          <SslConfigProvider>
            <SSLTlsOverviewPage />
          </SslConfigProvider>
        ),
      },
      {
        path: "ssl-tls/configuration",
        element: (
          <SslConfigProvider>
            <SSLTlsConfigurationPage />
          </SslConfigProvider>
        ),
      },
      {
        path: "certs",
        element: <LegacyCertsRedirect />,
      },
      {
        path: "reports",
        element: <NewReportsPage />,
      },
      {
        path: "settings/account",
        element: (
          <KeyProvider>
            <NewAccountSettingsPage />
          </KeyProvider>
        ),
      },
      {
        path: "settings/organisation",
        element: (
          <AdminProvider>
            <NewOrganisationSettingsPage />
          </AdminProvider>
        ),
      },
      {
        path: "settings/project",
        element: (
          <RBACProvider>
            <NewProjectSettingsPage />
          </RBACProvider>
        ),
      },
      {
        path: "settings/license",
        element: <NewLicensePage />,
      },
      {
        path: "settings/sso",
        element: (
          <IdPProvider>
            <DomainProvider>
              <IPRestrictionProvider>
                <SessionSettingsProvider>
                  <SSOPage />
                </SessionSettingsProvider>
              </IPRestrictionProvider>
            </DomainProvider>
          </IdPProvider>
        ),
      },
      {
        path: "settings/webhooks",
        element: (
          <AdminProvider>
            <SiteProvider>
              <ExternalWebhooksPage />
            </SiteProvider>
          </AdminProvider>
        ),
      },
      {
        path: "settings/audit-logs",
        element: <AuditLogsPage />,
      },
      {
        path: "settings/alerts",
        element: <AlertsPage />,
      },
      {
        path: "settings/integrations",
        element: <Navigate to="/v2/settings/webhooks" replace />,
      },
      {
        path: "settings/users",
        element: (
          <RBACProvider>
            <UserManagement />
          </RBACProvider>
        ),
      },
      {
        path: "detection/web_application/dashboard",
        element: (
          <EventProvider>
            <NewServicesWebApplicationDashboard />
          </EventProvider>
        ),
      },
      {
        path: "detection/web_application/dashboard/:categoryId",
        element: (
          <EventProvider>
            <WebApplicationDetectionList />
          </EventProvider>
        ),
      },
      {
        path: "detection/web_application/dashboard/:categoryId/detail",
        element: (
          <EventProvider>
            <WebApplicationDetectionDetail />
          </EventProvider>
        ),
      },
      {
        path: "detection/bot/dashboard",
        element: (
          <BMConfigProvider>
            <EventProvider>
              <NewServicesBotDashboard />
            </EventProvider>
          </BMConfigProvider>
        ),
      },
      {
        path: "detection/bot/dashboard/:categoryId",
        element: (
          <BMConfigProvider>
            <EventProvider>
              <BotDetectionList />
            </EventProvider>
          </BMConfigProvider>
        ),
      },
      {
        path: "detection/bot/dashboard/:categoryId/detail",
        element: (
          <BMConfigProvider>
            <EventProvider>
              <BotDetectionDetail />
            </EventProvider>
          </BMConfigProvider>
        ),
      },
      {
        path: "services/web_application/dashboard",
        element: (
          <EventProvider>
            <NewServicesWebApplicationDashboard />
          </EventProvider>
        ),
      },
      {
        path: "services/web_application/dashboard/:categoryId",
        element: (
          <EventProvider>
            <WebApplicationDetectionList />
          </EventProvider>
        ),
      },
      {
        path: "services/web_application/dashboard/:categoryId/detail",
        element: (
          <EventProvider>
            <WebApplicationDetectionDetail />
          </EventProvider>
        ),
      },
      {
        path: "services/waf_configuration",
        element: (
          <WAFRuleProvider>
            <WAFConfigurationStatus />
          </WAFRuleProvider>
        ),
      },
      {
        path: "services/web_application/config",
        element: (
          <WAFRuleProvider>
            <NewServicesWebApplicationConfig />
          </WAFRuleProvider>
        ),
      },
      {
        path: "services/web_application/exceptions",
        element: (
          <WAFRuleProvider>
            <NewServicesWebApplicationExceptions />
          </WAFRuleProvider>
        ),
      },
      {
        path: "services/web_application/custom_rules",
        element: (
          <WAFRuleProvider>
            <NewServicesWebApplicationCustomRules />
          </WAFRuleProvider>
        ),
      },
      {
        path: "services/rate_limit_rules",
        element: (
          <RateLimitProvider>
            <NewServicesRateLimitingRules />
          </RateLimitProvider>
        ),
      },
      {
        path: "services/bot/bm-exceptions",
        element: <Navigate to="/v2/services/bot/exception" replace />,
      },
      {
        path: "services/ddos/exceptions",
        element: (
          <DdosConfigProvider>
            <V2DdosExceptions />
          </DdosConfigProvider>
        ),
      },
      {
        path: "api-security",
        element: <AsecOverview />,
      },
      {
        path: "api-security/discovery",
        element: <AsecDiscovery />,
      },
      {
        path: "api-security/catalog",
        element: <AsecDiscovery />,
      },
      {
        path: "api-security/auth",
        element: <AsecAuth />,
      },
      {
        path: "api-security/schema",
        element: <AsecSchemaValidation />,
      },
      {
        path: "api-security/specs",
        element: <AsecSchemaValidation />,
      },
      {
        path: "api-security/dlp",
        element: <AsecDlp />,
      },
      {
        path: "api-security/graphql",
        element: <AsecGraphql />,
      },
      {
        path: "api-security/posture",
        element: <AsecPosture />,
      },
      {
        path: "api-security/anomaly",
        element: <AsecAnomaly />,
      },
      {
        path: "api-security/authorization",
        element: <AsecAuthorization />,
      },
      {
        path: "api-security/risk-score",
        element: <AsecRiskScore />,
      },
      {
        path: "api-security/threat-intel",
        element: <AsecThreatIntel />,
      },
      {
        path: "api-security/proposals",
        element: <AsecProposals />,
      },
      {
        path: "api-security/dependencies",
        element: <AsecDependencies />,
      },
      {
        path: "api-security/ai-callers",
        element: <AsecAiCallers />,
      },
      {
        path: "api-security/events",
        element: <AsecEvents />,
      },
      {
        path: "api-security/events_capture",
        element: <AsecEventsCapture />,
      },
      {
        path: "api-security/siem",
        element: <AsecSiem />,
      },
      {
        path: "services/firewall_rules",
        element: (
          <FirewallProvider>
            <NewServicesFirewallRules />
          </FirewallProvider>
        ),
      },
      {
        path: "services/bot/dashboard",
        element: (
          <BMConfigProvider>
            <EventProvider>
              <NewServicesBotDashboard />
            </EventProvider>
          </BMConfigProvider>
        ),
      },
      {
        path: "services/bot/dashboard/:categoryId",
        element: (
          <BMConfigProvider>
            <EventProvider>
              <BotDetectionList />
            </EventProvider>
          </BMConfigProvider>
        ),
      },
      {
        path: "services/bot/dashboard/:categoryId/detail",
        element: (
          <BMConfigProvider>
            <EventProvider>
              <BotDetectionDetail />
            </EventProvider>
          </BMConfigProvider>
        ),
      },
      {
        path: "services/bot/config",
        element: (
          <BMConfigProvider>
            <NewServicesBotConfig />
          </BMConfigProvider>
        ),
      },
      {
        path: "services/bot/exception",
        element: (
          <BMConfigProvider>
            <V2BmExceptions />
          </BMConfigProvider>
        ),
      },
      {
        path: "services/ddos_config",
        element: (
          <EventProvider>
            <DdosConfigProvider>
              <NewServicesDDosMigrationConfig />
            </DdosConfigProvider>
          </EventProvider>
        ),
      },
      {
        // Legacy path — the CSP redesign broke the single Configuration
        // tab into six focused pages. Keep this redirect so bookmarks
        // and Learn More deep-links continue to resolve.
        path: "csp/config",
        element: <Navigate to="/v2/csp/policy" replace />,
      },
      {
        path: "csp/inventory",
        element: (
          <CspConfigProvider>
            <NewServicesCspInventory />
          </CspConfigProvider>
        ),
      },
      {
        path: "csp/policy",
        element: (
          <CspConfigProvider>
            <NewServicesCspPolicy />
          </CspConfigProvider>
        ),
      },
      {
        path: "csp/violations",
        element: (
          <CspConfigProvider>
            <NewServicesCspViolations />
          </CspConfigProvider>
        ),
      },
      {
        path: "csp/routes",
        element: (
          <CspConfigProvider>
            <NewServicesCspRoutes />
          </CspConfigProvider>
        ),
      },
      {
        path: "csp/intelligence",
        element: (
          <CspConfigProvider>
            <NewServicesCspIntelligence />
          </CspConfigProvider>
        ),
      },
      {
        path: "csp/override",
        element: (
          <CspConfigProvider>
            <NewServicesCspOverride />
          </CspConfigProvider>
        ),
      },
      {
        path: "services/csp/config",
        element: <Navigate to="/v2/csp/policy" replace />,
      },
      {
        path: "services/csp/inventory",
        element: <Navigate to="/v2/csp/inventory" replace />,
      },
      {
        path: "services/csp/policy",
        element: <Navigate to="/v2/csp/policy" replace />,
      },
      {
        path: "services/csp/violations",
        element: <Navigate to="/v2/csp/violations" replace />,
      },
      {
        path: "services/csp/routes",
        element: <Navigate to="/v2/csp/routes" replace />,
      },
      {
        path: "services/csp/intelligence",
        element: <Navigate to="/v2/csp/intelligence" replace />,
      },
      {
        path: "services/csp/override",
        element: <Navigate to="/v2/csp/override" replace />,
      },
      {
        path: "mcp",
        element: <Navigate to="/v2/mcp/overview" replace />,
      },
      {
        path: "mcp/overview",
        element: <McpLicenseGate featureKey="mcp.insights"><NewServicesMcpOverview /></McpLicenseGate>,
      },
      {
        path: "mcp/endpoints",
        element: <McpLicenseGate featureKey="mcp.endpoints"><NewServicesMcpEndpointsList /></McpLicenseGate>,
      },
      {
        path: "mcp/events",
        element: <McpLicenseGate featureKey="mcp.insights"><NewServicesMcpEvents /></McpLicenseGate>,
      },
      {
        path: "mcp/configuration",
        element: <McpLicenseGate featureKey="mcp.endpoints"><NewServicesMcpConfig /></McpLicenseGate>,
      },
      {
        path: "mcp/settings",
        element: <McpLicenseGate featureKey="mcp.policy"><NewServicesMcpSettingsIndex /></McpLicenseGate>,
      },
      {
        path: "mcp/settings/:endpointId",
        element: <McpLicenseGate featureKey="mcp.policy"><NewServicesMcpEndpointSettings /></McpLicenseGate>,
      },
      {
        path: "mcp/onboard",
        element: <McpLicenseGate featureKey="mcp.endpoints"><NewServicesMcpOnboarding /></McpLicenseGate>,
      },
      {
        path: "mcp/tools",
        element: <McpLicenseGate featureKey="mcp.insights"><NewServicesMcpTools /></McpLicenseGate>,
      },
      {
        path: "mcp/sessions",
        element: <McpLicenseGate featureKey="mcp.insights"><NewServicesMcpSessions /></McpLicenseGate>,
      },
      {
        path: "mcp/approvals",
        element: <McpLicenseGate featureKey="mcp.policy"><NewServicesMcpApprovals /></McpLicenseGate>,
      },
      {
        path: "mcp/discovered",
        element: <McpLicenseGate featureKey="mcp.insights"><NewServicesMcpDiscovered /></McpLicenseGate>,
      },
      {
        path: "mcp/agents",
        element: <McpLicenseGate featureKey="mcp.insights"><NewServicesMcpAgents /></McpLicenseGate>,
      },
      {
        path: "mcp/policy-library",
        element: <McpLicenseGate featureKey="mcp.policy"><NewServicesMcpPolicyLibrary /></McpLicenseGate>,
      },
      {
        path: "mcp/alerts",
        element: <McpLicenseGate featureKey="mcp.alerts"><NewServicesMcpAlerts /></McpLicenseGate>,
      },
      {
        path: "mcp/reports",
        element: <McpLicenseGate featureKey="mcp.reports"><NewServicesMcpReports /></McpLicenseGate>,
      },
      {
        // Legacy — the earlier dialog-era settings path. Redirect to the new submenu entry.
        path: "mcp/configuration/:endpointId/settings",
        element: <Navigate to="/v2/mcp/settings" replace />,
      },
      {
        // Legacy — bookmarks + the earlier sidebar entry live here.
        path: "mcp/config",
        element: <Navigate to="/v2/mcp/configuration" replace />,
      },
      {
        path: "services/mcp/config",
        element: <Navigate to="/v2/mcp/configuration" replace />,
      },
    ],
  },
  {
    path: "",
    element: (
      <AuthGuard>
        <AuthLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
    ],
  },
];
export default routes;
